import { createContext, useContext } from "react";

export const MeetingContext = createContext();

function MeetingProvider(props) {
	return <MeetingContext.Provider {...props} />;
}

function useMeetingContext() {
	return useContext(MeetingContext);
}

export { MeetingProvider, useMeetingContext };
